<template>
  <div class="multi-store-trigger">
    <button
      v-if="current?.country?.code"
      class="multi-store-modal-overlay__close overlay__close icon-button text-body-xs-regular"
      type="button"
      :aria-label="$string('general.multi_store.suggestions.change')"
      @click.prevent="openMultiStoreModal"
      v-text="triggerText"
    />
  </div>
</template>

<script>

/**
 * Vue: Multi-store trigger (multi-store-trigger)
 * -----------------------------------------------------------------------------
 * Call to action to open the localization form modal.
 *
 */
import { mapState } from 'vuex'
import { replaceMultiStoreStrings } from '~/helpers/multi-store'

export default {
  name: 'MultiStoreTrigger',

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      current: (state) => state['multi-store'].current,
    }),

    triggerText() {
      if (!this.current?.country?.code) {
        return ''
      }

      return this.$string(
        'general.multi_store.trigger.label',
        { replace: replaceMultiStoreStrings(this.current.country) },
      )
    },
  },

  methods: {

    /**
     * Opens the multi-store modal
     */
    openMultiStoreModal() {
      cnvs.EventBus.emit('overlay:open-multi-store-modal')
    },
  },
}
</script>
